import { AnimationContext } from '../animationContext/AnimationContext'
import { type AnimationProps } from 'motion/react'
import { useContext } from 'react'

/**
 * Helper hook for getting the configuration for a motion presence animation
 * for an element.
 *
 * Note: The {@link AppearanceTransition} component may cover your needs,
 * rather than needing to use this hook directly
 */
export const useAppearanceTransition = (transformOrigin: 'top' | 'bottom'): AnimationProps => {
  const { animated, config } = useContext(AnimationContext)
  if (!animated) {
    return {}
  }

  const { duration, ease, startOpacity, startScale } = config.appearanceTransition
  const hiddenState = {
    opacity: startOpacity,
    transform: `scale(1, ${startScale})`,
    transformOrigin,
  }
  const visibleState = {
    opacity: 1,
    transform: 'scale(1, 1)',
    transformOrigin,
  }

  return {
    initial: hiddenState,
    animate: visibleState,
    exit: hiddenState,
    transition: { duration: duration, ease: ease },
  }
}
